export const validation = { // form validation errors here
    firm: {
        name: "",
        organization_juridical_address: "",
        organization_inn: "",
        organization_kpp: "",
        organization_bank_account2: "",
        organization_bank_account1: "",
        organization_bik: "",
    },
}
